import Vue from "vue";
import App from "./App";
import router from "./router/index";
import Api from "./api";
import Auth from "./auth";

import VueNotify from 'vue-notifyjs'
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

import VModal from 'vue-js-modal'
import 'vue-js-modal/dist/styles.css'

Vue.use(VueNotify)
Vue.use(PaperDashboard);
Vue.use(VModal);

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App),
  data : {
    loggedUser: null,
    activeListeners: []
  },
  methods: {
    getLoggedUser() {
      return this.loggedUser;
    },
    setLoggedUser(loggedUser) {
        this.loggedUser = loggedUser;
        Auth.setLoggedUser(loggedUser);
    },
    deleteLoggedUser() {
      this.loggedUser = null;
      Auth.deleteLoggedUser();
    },
    logout() {
      Api.send("POST", "/user/logout", {})
      .then(() => {
        this.deleteLoggedUser();
        this.$router.push({name: 'login'})
      })
      .catch((err) => {
        alert(err.msg);
        this.deleteLoggedUser();
        this.$router.push({name: 'login'})
      });
    },
    canUserDo (actions) {
      return Auth.canUserDo(actions, this.loggedUser);
    },
    notifyy(type, message) {
      let icon = null;
      switch (type) {
          case 'success':
              icon = 'ti-check-box';
              break;
          case 'danger':
              icon = 'ti-alert';
              break;
          case 'info':
              icon = 'ti-bell';
              break;
      }
      this.$notify({
          message: message,
          icon: icon,
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: type
        });
    },
    isActiveListener(listenerName) {
      if (this.activeListeners.indexOf(listenerName) === -1) {
        return false;
      }
      return true;
    },
    addActiveListener(listenerName) {
      if (this.activeListeners.indexOf(listenerName) === -1) {
        this.activeListeners.push(listenerName);
      }
    }
  },
  mounted() {
    this.loggedUser = Auth.getLoggedUser();
  }
}).$mount("#app");
